export class ControlsManager {
    constructor(options) {
        this.bindings = [];
        this.hyperspeedPending = false;
        this.dom = options.dom;
        this.controls = options.controls;
        this.schemes = options.schemes;
        this.movementFactories = options.movementFactories;
        this.actionHandlers = options.actionHandlers;
        this.context = options.context;
        const scheme = this.schemes[options.initialSchemeId];
        if (!scheme) {
            throw new Error(`ControlsManager: unknown scheme '${options.initialSchemeId}'`);
        }
        this.scheme = scheme;
        this.movementScheme = this.createMovementScheme(scheme);
        this.enableScheme();
    }
    setScheme(id) {
        const next = this.schemes[id];
        if (!next)
            throw new Error(`ControlsManager: unknown scheme '${id}'`);
        if (next.id === this.scheme.id)
            return;
        this.disableScheme();
        this.scheme = next;
        this.movementScheme = this.createMovementScheme(next);
        this.enableScheme();
    }
    getCurrentSchemeId() {
        return this.scheme.id;
    }
    sampleIntent() {
        const base = this.movementScheme.sample();
        if (this.hyperspeedPending) {
            this.hyperspeedPending = false;
            return Object.assign(Object.assign({}, base), { toggleHyperspeed: true });
        }
        return base;
    }
    requestHyperspeedToggle() {
        this.hyperspeedPending = true;
    }
    dispose() {
        this.disableScheme();
    }
    createMovementScheme(scheme) {
        const factory = this.movementFactories[scheme.movement];
        if (!factory) {
            throw new Error(`ControlsManager: missing movement factory '${scheme.movement}'`);
        }
        return factory();
    }
    enableScheme() {
        this.movementScheme.enable();
        this.bindings = this.scheme.bindings.map(def => this.bindBinding(def));
    }
    disableScheme() {
        var _a;
        (_a = this.movementScheme) === null || _a === void 0 ? void 0 : _a.disable();
        this.bindings.forEach(binding => {
            binding.target.removeEventListener(binding.event, binding.handler, binding.options);
        });
        this.bindings = [];
    }
    bindBinding(def) {
        const target = this.resolveTarget(def.target);
        const handler = (event) => {
            if (def.keys && event instanceof KeyboardEvent) {
                if (!def.keys.includes(event.code))
                    return;
            }
            if (typeof def.button === 'number' && event instanceof MouseEvent) {
                if (event.button !== def.button)
                    return;
            }
            const actionHandler = this.actionHandlers[def.action];
            if (!actionHandler)
                return;
            actionHandler(event, this.context);
            if (def.preventDefault) {
                event.preventDefault();
            }
            if (def.stopPropagation) {
                event.stopPropagation();
            }
        };
        target.addEventListener(def.event, handler, def.options);
        return { target, event: def.event, handler, options: def.options };
    }
    resolveTarget(target) {
        switch (target) {
            case 'window':
                return window;
            case 'document':
                return document;
            case 'dom':
                return this.dom;
            default:
                return this.dom;
        }
    }
}
